import { Typography } from "@mui/material";
import React from "react";

import { IIntroGreetingProps } from "./IIntroGreetingProps";

/** Displays final confirmation for the PA to read. */
const IntroConfirmation: React.FC<IIntroGreetingProps> = ({ userFirstName, customerFirstName, outbound }) => {
  const language = outbound
    ? `Hi, ${customerFirstName}! This is ${userFirstName} from Sono Bello; calling regarding the consultation you requested! Which areas of the body would you like to transform?`
    : "Great, thank you! I’d love to get you set up with a free consultation. Which areas of the body would you like to work on?";

  return <Typography variant="body2">{language}</Typography>;
};

export default IntroConfirmation;
